export default __webpack_public_path__ + "static/header-72f6af054b7f4199ba97be3aa1792f6d.png";